import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";


const styles = theme => ({
	actionRow: {
		display: 'flex',
		justifyContent: 'space-between',
		margin: '20px 0 25px',

		"& > span": {
			color: "#1972e7",
			cursor: "pointer",
			fontWeight: 500,
			lineHeight: '32px',
		},

		"& > button":{
			backgroundColor: "#1972e7",
			color:  'white',
			"&:hover": {
				backgroundColor: "#0864E7"
			}
		}
	},
});

function ActionRow(props){
	const { classes,
		spanOnClick,
		spanText,
		buttonText,
		isButtonDisabled} = props;

	return (
		<div className={classes.actionRow}>
					<span onClick={spanOnClick}>
						{spanText}
					</span>
			<Button
				type="submit"
				variant="contained"
				// onClick={ButtonOnClick}
				disabled={isButtonDisabled}
			>
				{buttonText}
			</Button>
		</div>
	)
}

ActionRow.propTypes = {
	spanText: PropTypes.string.isRequired,
	buttonText: PropTypes.string.isRequired,

	spanOnClick: PropTypes.func.isRequired,

};

export default withStyles(styles)(ActionRow);